import React from 'react'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
import { share } from 'utils'

export default class Share extends React.Component {
  // constructor(props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }

  handleShare = () => {
    share(this.props.data)
  }

  render() {
    return (
      <div className={classes.componentsShare}>
        <i className='iconfont iconcomm-share white' onClick={this.handleShare} />
      </div>
    )
  }
}
